import defaultAnfallsanamneseState from "../vuex/anfallsanamnese/state"
import defaultTechnischeUntersuchungenState from "../vuex/technische-untersuchungen/state"
import defaultDiagnosestellungState from "../vuex/diagnosestellung/state"
import defaultTherapieState from "../vuex/therapie/state"

function emptyCdssDocumentForPatient(patientData) {
    return {
        patientId: patientData.id,
        anfallsanamnese: defaultAnfallsanamneseState(),
        technischeUntersuchungen: defaultTechnischeUntersuchungenState(),
        diagnosestellung: defaultDiagnosestellungState(),
        therapie: defaultTherapieState()
    }
}

export default {
    loadPatientData({commit, state}, patientData,) {
        const emptyCdssDocument = emptyCdssDocumentForPatient(patientData);
        commit("setAnfallsanamnese", emptyCdssDocument.anfallsanamnese)
        commit("setTechnischeUntersuchungen", emptyCdssDocument.technischeUntersuchungen)
        commit("setDiagnosestellung", emptyCdssDocument.diagnosestellung)
        commit("setTherapie", emptyCdssDocument.therapie)

        state.showLoadingModal = false
    },
}